const knowledge = [
{
    "name": "Accuracy Training",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, survivalism",
    "rules": "Theory",
    "observationCondition": "When you successfully hit the monster, gain +1 observation. Limit once per attack.",
    "boxes": 6,
    "levelUp": "Advance Accuracy Training II"
    },
    {
    "name": "Accuracy Training",
    "level": "II",
    "lumiCost": 1,
    "traits": "knowledge, survivalism",
    "rules": "+1 accuracy",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Adrenaline Junkie",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, dreamism",
    "rules": "When you attack with 3+ speed and draw the trap, you are elated! Gain +1 luck token.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Affirmation",
    "level": null,
    "lumiCost": 8,
    "traits": "knowledge, regalism",
    "rules": "It is all real! You can spend insanity as though it were survival.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "All for One",
    "level": "I",
    "lumiCost": 1,
    "traits": "knowledge, tenet, collectivism",
    "rules": "With their permission, you can spend other survivors' survival as though it were your own. Limit once per round.",
    "observationCondition": "When another survivor lets you spend their survival, gain +1 observation.",
    "boxes": 4,
    "levelUp": "All for One II"
    },
    {
    "name": "All for One",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, tenet, collectivism",
    "rules": "With their permission, you can spend other survivors' survival as though it were your own. Limit twice per round.",
    "observationCondition": "When another survivor lets you spend their survival, gain +1 observation.",
    "boxes": 8,
    "levelUp": "All for One III"
    },
    {
    "name": "All for One",
    "level": "III",
    "lumiCost": 3,
    "traits": "knowledge, tenet, collectivism",
    "rules": "With their permission, you can spend other survivors' survival as though it were your own.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Appreciation",
    "level": null,
    "lumiCost": 5,
    "traits": "knowledge, gourmandism",
    "rules": "During the showdown, when you would archive a resource or gear, roll 1d10. On a 6+, you keep it instead.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Aspirational Ethos",
    "level": null,
    "lumiCost": 5,
    "traits": "knowledge, ambitionism",
    "rules": "+1 strength for every 10 collective cognition the settlement has.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": ""
    },
    {
    "name": "Believe in Yourself",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, optimism",
    "rules": "You believe in yourself. You are guardless. On Arrival, if your survival is at the settlement's survival limit, gain +1 evasion token.",
    "observationCondition": "During the Aftermath, if you have no filled heavy injury boxes, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Believe in Yourself II"
    },
    {
    "name": "Believe in Yourself",
    "level": "II",
    "lumiCost": 3,
    "traits": "knowledge, optimism",
    "rules": "You believe in yourself. You are guardless. On Arrival, if your survival is at the settlement's survival limit, gain +2 evasion tokens.",
    "observationCondition": "During the Aftermath, if you have no filled injury boxes, gain +1 observation.",
    "boxes": 4,
    "levelUp": "Believe in Yourself III"
    },
    {
    "name": "Believe in Yourself",
    "level": "III",
    "lumiCost": 6,
    "traits": "knowledge, optimism",
    "rules": "You brim with confidence. You are guardless. On Arrival, if your survival is at the settlement's survival limit, gain +3 evasion tokens.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Better Than This",
    "level": null,
    "lumiCost": 3,
    "traits": "knowledge, optimism",
    "rules": "You turn negative thoughts into positive energy. During your act, you may spend up to 5 insanity to gain that much survival. Limit once per showdown.",
    "observationCondition": "When you suffer a brain trauma, gain +1 dangerous observation.",
    "boxes": 2,
    "levelUp": "Lose this knowledge and gain a random disorder."
    },
    {
    "name": "Blackheart",
    "level": null,
    "lumiCost": 3,
    "traits": "knowledge, deadism",
    "rules": "On Arrival, gain +1 strength token. Add your number of +1 strength tokens to your brain trauma rolls.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Blood Dancer",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, monster, crimson crocodile",
    "rules": "Theory",
    "observationCondition": "When you gain a bleeding token, gain +1 observation.",
    "boxes": 4,
    "levelUp": "Blood Dancer II"
    },
    {
    "name": "Blood Dancer",
    "level": "II",
    "lumiCost": 3,
    "traits": "knowledge, monster, crimson crocodile",
    "rules": "+1 strength for each of your bleeding tokens. While you have any bleeding tokens, you lose yourself to the blood and are guardless.",
    "observationCondition": "When you wound the monster while guardless, gain +1 observation.",
    "boxes": 6,
    "levelUp": "Blood Dancer III"
    },
    {
    "name": "Blood Dancer",
    "level": "III",
    "lumiCost": 4,
    "traits": "knowledge, monster, crimson crocodile",
    "rules": "+1 strength for each of your bleeding tokens.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Braggart",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, optimism",
    "rules": "You are keenly aware of how great your are. When you encourage a survivor, you tell them all about it! Gain +2 survival as they lose 1 survival in frustration.",
    "observationCondition": "When you are encouraged, gain +1 dangerous observation.",
    "boxes": 3,
    "levelUp": "Lose this knowledge and gain a random disorder."
    },
    {
    "name": "The Breaking Point",
    "level": null,
    "lumiCost": 1,
    "traits": "knowledge, impermanism",
    "rules": "You take note of when things break.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": "+1 luck to wound attempts on hit locations with a persistent injury."
    },
    {
    "name": "Call the Storm",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, regalism",
    "rules": "Channel your faith. Once per round, you may spend 2 insanity to give your next wound attempt bonus strength equal to your weapon's proficiency.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Call to Arms",
    "level": null,
    "lumiCost": 3,
    "traits": "knowledge, regalism",
    "rules": "Your faithful and resilient battle cry is inspiring. During your act, you may set all other survivors' insanity equal to your insanity. Limit once per showdown.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Chosen",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, tenet, champion",
    "rules": "Theory",
    "observationCondition": "When you make a dangerous observation, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Chosen II"
    },
    {
    "name": "Chosen",
    "level": "II",
    "lumiCost": 0,
    "traits": "knowledge, tenet, champion",
    "rules": "You deny the possibility that you serve a sinister purpose. You may erase an observation from another knowledge you possess.",
    "observationCondition": "When you erase an observation using this knowledge, gain +1 observation.",
    "boxes": 4,
    "levelUp": "Chosen III"
    },
    {
    "name": "Chosen",
    "level": "III",
    "lumiCost": 0,
    "traits": "knowledge, tenet, champion",
    "rules": "You cannot bear to face the truth. You may record a permanent injury you do not already have to erase an observation from another knowledge you possess.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Combat Conviction",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, regalism",
    "rules": "A clean strike confirms your faith. When you Perfect hit with a sword, gain +1d5 insanity.",
    "observationCondition": "When you Perfect hit with a sword, gain +1 observation.",
    "boxes": 2,
    "levelUp": "Combat Conviction II"
    },
    {
    "name": "Combat Conviction",
    "level": "II",
    "lumiCost": 3,
    "traits": "knowledge, regalism",
    "rules": "Combat confirms your faith. When you Perfect hit with a sword or when you Block / Deflect a hit, gain +1d5 insanity.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Dark Eye",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, deadism",
    "rules": "Theory",
    "observationCondition": "On a Perfect hit, gain +1 observation.",
    "boxes": 6,
    "levelUp": "Dark Eye II"
    },
    {
    "name": "Dark Eye",
    "level": "II",
    "lumiCost": 3,
    "traits": "knowledge, deadism",
    "rules": "+1 accuracy, +1 systemic pressure. Increase the range of your Perfect hits by 1 (an attack roll of 9 or 10 will be a Perfect hit).",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Dark Impulse",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, tenet, homicidalism",
    "rules": "Theory",
    "observationCondition": "When you inflict the killing blow on a monster or murder a survivor, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Dark Impulse II"
    },
    {
    "name": "Dark Impulse",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, tenet, homicidalism",
    "rules": "Death invigorates you. When you inflict the killing blow on a monster or murder a survivor, roll 1d10. On a 6+, gain +1 strength.",
    "observationCondition": "When you are the only survivor to return from a victorious showdown, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Dark Impulse III"
    },
    {
    "name": "Dark Impulse",
    "level": "III",
    "lumiCost": 6,
    "traits": "knowledge, tenet, homicidalism",
    "rules": "You are the ultimate provider; all must support your heroism. While adjacent to another survivor, you may spend 1 survival to murder them. When you kill another survivor, gain all their positive attributes.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Darkness",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, starting",
    "rules": "There is something out to get you. +1 torment",
    "observationCondition": "When you suffer brain damage, gain +1 observation.",
    "boxes": 5,
    "levelUp": "Darkness II"
    },
    {
    "name": "Darkness",
    "level": "II",
    "lumiCost": 3,
    "traits": "knowledge, starting",
    "rules": "You let the darkness in. Add +1 to your brain trauma roll results.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Death Collector",
    "level": "I",
    "lumiCost": 1,
    "traits": "knowledge, tenet, lanternism",
    "rules": "When a survivor dies on the showdown board, replace their miniature with a Fallen Lantern terrain tile.",
    "observationCondition": "When you activate a Fallen Lantern, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Death Collector II"
    },
    {
    "name": "Death Collector",
    "level": "II",
    "lumiCost": 1,
    "traits": "knowledge, tenet, lanternism",
    "rules": "When a survivor dies on the showdown board, replace their miniature with a Fallen Lantern terrain tile. Gain +1 strength and +1 accuracy while you have a death token.",
    "observationCondition": "When you activate a Fallen Lantern, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Death Collector III"
    },
    {
    "name": "Death Collector",
    "level": "III",
    "lumiCost": 2,
    "traits": "knowledge, tenet, lanternism",
    "rules": "When a survivor dies on the showdown board, replace their miniature with a Fallen Lantern terrain tile. Gain +1 strength, +1 accuracy, and +1 evasion while you have a death token.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Death Education",
    "level": null,
    "lumiCost": 6,
    "traits": "knowledge, ambitionism",
    "rules": "When you use Range, Block, Deflect, Mindlock, or Deadly, increase the effect by 1 for every 20 collective cognition in the settlement.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Death Poet",
    "level": "I",
    "lumiCost": 1,
    "traits": "knowledge, tenet, deadism",
    "rules": "When you suffer a brain trauma, gain +1 strength token. Limit once per showdown.",
    "observationCondition": "When you suffer a brain trauma, gain +1 observation.",
    "boxes": 2,
    "levelUp": "Death Poet II"
    },
    {
    "name": "Death Poet",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, tenet, deadism",
    "rules": "When you suffer a brain trauma, gain +1 strength token.",
    "observationCondition": "When you suffer a brain trauma, gain +1 observation.",
    "boxes": 5,
    "levelUp": "Death Poet III"
    },
    {
    "name": "Death Poet",
    "level": "III",
    "lumiCost": 3,
    "traits": "knowledge, tenet, deadism",
    "rules": "When you suffer a brain trauma, gain +1 strength token. If you would die from a brain trauma, you externalize your suffering with a traumatic poem. All other non-deaf survivors suffer 3 brain damage instead. Limit once per showdown.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Death Sense",
    "level": "I",
    "lumiCost": 1,
    "traits": "knowledge, survivalism",
    "rules": "Theory",
    "observationCondition": "When you dodge, gain +1 observation.",
    "boxes": 8,
    "levelUp": "Death Sense II"
    },
    {
    "name": "Death Sense",
    "level": "II",
    "lumiCost": 1,
    "traits": "knowledge, survivalism",
    "rules": "You may dodge 1 additional time per round.",
    "observationCondition": "When you dodge for the second time in a round, gain +1 observation.",
    "boxes": 4,
    "levelUp": "Death Sense III"
    },
    {
    "name": "Death Sense",
    "level": "III",
    "lumiCost": 5,
    "traits": "knowledge, survivalism",
    "rules": "You may dodge 1 additional time per round and you may dodge while you are attacking or doomed.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Death's Edge",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, survivalism",
    "rules": "+1 systemic pressureGain +1 strength for each systemic pressure you have.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": ""
    },
    {
    "name": "Deconstructive Mind",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, impermanism",
    "rules": "Thoughts are not permanent. When you gain a disorder, you may replace one of your disorders with it.",
    "observationCondition": "When you use this, gain +1 observation.",
    "boxes": 6,
    "levelUp": "Deconstructive Mind II"
    },
    {
    "name": "Deconstructive Mind",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, impermanism",
    "rules": "When you gain a disorder, you may gain +1 lumi instead. Limit once per lantern year.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Demagogue",
    "level": "I",
    "lumiCost": 1,
    "traits": "knowledge, survivalism",
    "rules": "When you encourage another survivor, they gain +1 insanity.",
    "observationCondition": "When you encourage, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Demagogue II"
    },
    {
    "name": "Demagogue",
    "level": "II",
    "lumiCost": 1,
    "traits": "knowledge, survivalism",
    "rules": "When you encourage another survivor, they gain +2 insanity.",
    "observationCondition": "When you encourage, gain +1 observation.",
    "boxes": 6,
    "levelUp": "Demagogue III"
    },
    {
    "name": "Demagogue",
    "level": "III",
    "lumiCost": 3,
    "traits": "knowledge, survivalism",
    "rules": "+1 torment. When you perform encourage, all non-deaf survivors are affected. When you encourage a survivor, they gain +2 insanity.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Despair",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, starting",
    "rules": "Theory",
    "observationCondition": "When you suffer a brain trauma, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Despair II"
    },
    {
    "name": "Despair",
    "level": "II",
    "lumiCost": 0,
    "traits": "knowledge, starting",
    "rules": "If nightmares are real, then are you a living nightmare? When you depart, gain +1 insanity.",
    "observationCondition": "When you suffer a brain trauma, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Despair III"
    },
    {
    "name": "Despair",
    "level": "III",
    "lumiCost": 1,
    "traits": "knowledge, starting",
    "rules": "Nightmares are real and dreams are the wisdom of the dead. While you sleep, they fill you with guidance. When you depart, gain +2 insanity.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Desperate Strike",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, survivalism",
    "rules": "Theory",
    "observationCondition": "On a Perfect hit, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Desperate Strike II"
    },
    {
    "name": "Desperate Strike",
    "level": "II",
    "lumiCost": 1,
    "traits": "knowledge, survivalism",
    "rules": "Your desperation becomes your strength. On a Perfect hit, gain +2 strength until the end of the attack.",
    "observationCondition": "On a Perfect hit, gain +1 observation.",
    "boxes": 6,
    "levelUp": "Desperate Strike III"
    },
    {
    "name": "Desperate Strike",
    "level": "III",
    "lumiCost": 2,
    "traits": "knowledge, survivalism",
    "rules": "You master your explosive desperation. On a Perfect hit, gain +4 strength until the end of the attack.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Digestion",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, gourmandism",
    "rules": "You may spend activation to consume one of your positive attribute tokens. Archive it. Limit once per lantern year.",
    "observationCondition": "When you consume an attribute token, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Digestion II"
    },
    {
    "name": "Digestion",
    "level": "II",
    "lumiCost": 6,
    "traits": "knowledge, gourmandism",
    "rules": "You may spend activation to consume one of your positive attribute tokens. Archive it and gain its effects permanently. Limit once per lantern year.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Dissociation",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, deadism",
    "rules": "You see the world as a game board and yourself as a pawn. When you suffer a brain trauma, place your survivor in any unoccupied space within 5 spaces of your current space.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Dreamless Sleep",
    "level": null,
    "lumiCost": 0,
    "traits": "knowledge, dreamism",
    "rules": "This knowledge can be removed only by its own observation. You sleep a blissfully dreamless sleep. Ignore the effects of your disorders.",
    "observationCondition": "When you depart and there is no Keeper of Dreams settlement location, gain +1 dangerous observation.",
    "boxes": 1,
    "levelUp": "Lose this knowledge and gain +1 permanent torment."
    },
    {
    "name": "Eight Eyes",
    "level": null,
    "lumiCost": 3,
    "traits": "knowledge, collectivism",
    "rules": "On Arrival, if the survivors have more functioning eyes than the monster, they ambush the monster.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Envenom Edge",
    "level": "I",
    "lumiCost": 3,
    "traits": "knowledge, verminism",
    "rules": "When you hit the monster at least two times in one attack, it gains a venom token. When a monster has 3 or more venom tokens, it feels the effects of the poison and suffers 1 wound. Then archive all of its venom tokens.",
    "observationCondition": "When the monster suffers a wound from venom, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Envenom Edge II"
    },
    {
    "name": "Envenom Edge",
    "level": "II",
    "lumiCost": 5,
    "traits": "knowledge, verminism",
    "rules": "When you hit the monster at least two times in one attack, it gains a venom token. When a monster has 2 or more venom tokens, it feels the effects of the poison and suffers 1 wound. Then archive all of its venom tokens.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Eudaimonia",
    "level": null,
    "lumiCost": 6,
    "traits": "knowledge, romanticism",
    "rules": "When you make an observation, gain +1 understanding. Before making a would roll, you may spend any amount of understanding to gain that much luck for that would attempt.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Evasion Training",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, survivalism",
    "rules": "Theory",
    "observationCondition": "When you are targeted, gain +1 observation.",
    "boxes": 5,
    "levelUp": "Evasion Training II"
    },
    {
    "name": "Evasion Training",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, survivalism",
    "rules": "+1 evasion, +1 torment. You remain light on your feet. When you depart, subtract 2 armor from the legs.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Evermore",
    "level": "I",
    "lumiCost": 3,
    "traits": "knowledge, deadism",
    "rules": "You know that this world is the afterlife. You are Undeathable.",
    "observationCondition": "Whenever you inexpicably survive, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Evermore II"
    },
    {
    "name": "Evermore",
    "level": "II",
    "lumiCost": 1,
    "traits": "knowledge, deadism",
    "rules": "You were astoundingly wrong! Even if this is the afterlife, you can still die, and worse yet, the next world is even more horrific than this one. Activation: Your fear peaks. Suffer a random brain trauma.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Fear",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, starting",
    "rules": "Theory",
    "observationCondition": "When you suffer damage, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Fear II"
    },
    {
    "name": "Fear",
    "level": "II",
    "lumiCost": 1,
    "traits": "knowledge, starting",
    "rules": "When a monster targets you, you may spend 1 survival to suffer the flee brain trauma. Limit once per showdown.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Find the Castle",
    "level": "I",
    "lumiCost": 3,
    "traits": "knowledge, tenet, regalism",
    "rules": "You find a new way to move. Perhaps it will take you to the sky. While insane, you may move 1 space diagonally during a Movement action.",
    "observationCondition": "When you use this, gain +1 observation.",
    "boxes": 8,
    "levelUp": "Find the Castle II"
    },
    {
    "name": "Find the Castle",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, tenet, regalism",
    "rules": "You are getting closer. While insane, you may move up to 2 spaces diagonally during a Movement action.",
    "observationCondition": "When you use this, gain +1 observation.",
    "boxes": 8,
    "levelUp": "Find the Castle III"
    },
    {
    "name": "Find the Castle",
    "level": "III",
    "lumiCost": 5,
    "traits": "knowledge, tenet, regalism",
    "rules": "Closer still. While insane, you may move up to 3 spaces diagonally during a Movement action.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Fingernail Door",
    "level": "I",
    "lumiCost": 1,
    "traits": "knowledge, dreamism",
    "rules": "You feel something escape from the tips of your fingers. The sensation is oddly refreshing. When you roll a lantern 10, before anything else happens, physically rotate the die to a 1 and gain +1 insanity.",
    "observationCondition": "When you use this knowledge, gain +1 observation.",
    "boxes": 5,
    "levelUp": "Fingernail Door II"
    },
    {
    "name": "Fingernail Door",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, dreamism",
    "rules": "You feel as if your fortune is being devoured by something in the darkness. The experience fills you with ecstacy. When you roll a lantern 10, before anything else happens, physically rotate the die to a 1 and gain +3 insanity.",
    "observationCondition": "During the Aftermath, if you have 13+ insanity, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Fingernail Door III"
    },
    {
    "name": "Fingernail Door",
    "level": "III",
    "lumiCost": 7,
    "traits": "knowledge, dreamism",
    "rules": "You breathe in the fortune of others. The first time another survivor rolls a lantern 10 during the showdown, before anything else happens, physically rotate the die to a 1 and gain +1 permanent luck.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Font of Ingenuity",
    "level": null,
    "lumiCost": 7,
    "traits": "knowledge, ambitionism",
    "rules": "When you depart, convert all unspent endeavors into reroll tokens for yourself.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Fortis Fortuna",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, romanticism",
    "rules": "You flourish on the battlefield. On a Perfect hit, gain +1 lumi. Limit once per round.",
    "observationCondition": "When you spend lumi, gain that amount of observations.",
    "boxes": 5,
    "levelUp": "Fortis Fortuna II"
    },
    {
    "name": "Fortis Fortuna",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, romanticism",
    "rules": "Vision from glory. On a Perfect hit, gain +1 lumi.",
    "observationCondition": "When you spend lumi, gain that amount of observations.",
    "boxes": 8,
    "levelUp": "Foris Fortuna III"
    },
    {
    "name": "Fortis Fortuna",
    "level": "III",
    "lumiCost": 5,
    "traits": "knowledge, romanticism",
    "rules": "On a Perfect hit, gain +1 lumi. On Arrival, you may spend 3 lumi to increase the range of your Perfect hits by 1 this lantern year.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Fortune & Misfortune",
    "level": "I",
    "lumiCost": 3,
    "traits": "knowledge, tenet, wanderer, luck",
    "rules": "On Arrival, gain +1 luck token, and all other survivors gain +1 systemic pressure token.",
    "observationCondition": "When you critically wound, gain +1 observation.",
    "boxes": 9,
    "levelUp": "Fortune & Misfortune II"
    },
    {
    "name": "Fortune & Misfortune",
    "level": "II",
    "lumiCost": 6,
    "traits": "knowledge, tenet, wanderer, luck",
    "rules": "On Arrival, gain +2 luck tokens, and all other survivors gain +2 systemic pressure tokens.",
    "observationCondition": "When a survivor with systemic pressure tokens dies from a severe injury, gain +1 observation.",
    "boxes": 6,
    "levelUp": "Fortune & Misfortune III"
    },
    {
    "name": "Fortune & Misfortune",
    "level": "III",
    "lumiCost": 9,
    "traits": "knowledge, tenet, wanderer, luck",
    "rules": "On Arrival, gain +3 luck tokens, and all other survivors gain +3 systemic pressure tokens.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Freedom",
    "level": null,
    "lumiCost": 6,
    "traits": "knowledge, romanticism",
    "rules": "Once per round, you may spend 1 lumi to perform a survival action, including repeating survival actions you already performed.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Gambler's Grace",
    "level": null,
    "lumiCost": 8,
    "traits": "knowledge, dreamism",
    "rules": "+2 systemic pressure, +1 luck. When you roll a 1 during the hunt or showdown phase, lose 1 survival and reroll it.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Gastromancer",
    "level": null,
    "lumiCost": 4,
    "traits": "knowledge, gourmandism",
    "rules": "Room for some more. When you depart, gain the Second Stomach survivor status card.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Ghostzerker",
    "level": null,
    "lumiCost": 5,
    "traits": "knowledge, lanternism",
    "rules": "Subconscious. The light of the dead shines within you. Treat all your tokens, including ones on survivor status cards, as death tokens.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Guardian",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, tenet, dreamism",
    "rules": "The others are your burden to bear. You must protect them, whatever the cost. After an adjacent survivor makes a roll, you may intervene. Gain +1 systemic pressure token and reroll one of their roll results. Limit once per showdown.",
    "observationCondition": "When you use this knowledge, gain +1 observation.",
    "boxes": 2,
    "levelUp": "Guardian II"
    },
    {
    "name": "Guardian",
    "level": "II",
    "lumiCost": 3,
    "traits": "knowledge, tenet, dreamism",
    "rules": "You imagine yourself the sole protector, carrying everyone on your shoulders. After a survivor in your field of view makes a roll, you may intervene. Gain +1 systemic pressure token and reroll one of their roll results. Limit once per showdown.",
    "observationCondition": "When you use this knowledge, gain +1 observation.",
    "boxes": 4,
    "levelUp": "Guardian III"
    },
    {
    "name": "Guardian",
    "level": "III",
    "lumiCost": 4,
    "traits": "knowledge, tenet, dreamism",
    "rules": "After a survivor in your field of view makes a roll, you may intervene. Gain +1 systemic pressure token and reroll one of their roll results. Limit twice per showdown.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Hardy Ego",
    "level": null,
    "lumiCost": 1,
    "traits": "knowledge, impermanism",
    "rules": "When you would suffer a brain trauma, instead draw two knowledges. Replace this with one of them.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Health",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, tenet, gourmandism",
    "rules": "When you consume during the hunt or showdown, gain +1 strength token.",
    "observationCondition": "When you consume during the hunt or showdown, gain +1 observation.",
    "boxes": 4,
    "levelUp": "Health II"
    },
    {
    "name": "Health",
    "level": "II",
    "lumiCost": 3,
    "traits": "knowledge, tenet, gourmandism",
    "rules": "When you consume during the hunt or showdown, gain +1 strength or accuracy token.",
    "observationCondition": "When you consume during the hunt or showdown, gain +1 observation.",
    "boxes": 5,
    "levelUp": "Health III"
    },
    {
    "name": "Health",
    "level": "III",
    "lumiCost": 4,
    "traits": "knowledge, tenet, gourmandism",
    "rules": "Whenever you consume during the hunt or showdown, gain +1 strength, accuracy, or speed token.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Herb Grinder",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, monster, screaming antelope",
    "rules": "Theory",
    "observationCondition": "When you gain Fresh Acanthus, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Herb Grinder II"
    },
    {
    "name": "Herb Grinder",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, monster, screaming antelope",
    "rules": "Movement, Activation: Archive a Fresh Acanthus to grind it into a medicinal paste. Your or an adjacent survivor fully heal 2 hit locations.",
    "observationCondition": "When you grind Fresh Acanthus into a medicinal paste, gain +1 observation.",
    "boxes": 4,
    "levelUp": "Herb Grinder III"
    },
    {
    "name": "Herb Grinder",
    "level": "III",
    "lumiCost": 3,
    "traits": "knowledge, monster, screaming antelope",
    "rules": "Movement, Activation: Archive a Fresh Acanthus to grind it into a medicinal paste. You or an adjacent survivor fully heal all hit locations.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "High Roller",
    "level": "I",
    "lumiCost": 5,
    "traits": "knowledge, dreamism",
    "rules": "+1 torment. You may steal a d10 from an attack roll made against you. If you do, the speed of the attack is reduced by 1 (negating the hit). Place the stolen d10 aside with the roll result unchanged. You cannot steal a d10 while you have one stolen. After your wound attempt roll, you may replace the roll result with the stolen d10 and its roll result.",
    "observationCondition": "On replacing a d10 with a stolen d10, gain +1 observation.",
    "boxes": 5,
    "levelUp": "High Roller II"
    },
    {
    "name": "High Roller",
    "level": "II",
    "lumiCost": 8,
    "traits": "knowledge, dreamism",
    "rules": "+1 torment. You may steal a d10 from an attack roll made against you. If you do, the speed of the attack is reduced by 1 (negating the hit). Place the stolen d10 aside with the roll result unchanged. You cannot steal a d10 while you have one stolen. During your attack, you may replace any single roll result with the stolen d10 and its roll result.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Hissing Arms",
    "level": "I",
    "lumiCost": 3,
    "traits": "knowledge, tenet, verminism",
    "rules": "All your weapons gain paired. You cannot pair two-handed weapons this way. While you have paired weapons in your gear grid, you may spend activation to Deflect 1.",
    "observationCondition": "When you make a paired attack, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Hissing Arms II"
    },
    {
    "name": "Hissing Arms",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, tenet, verminism",
    "rules": "All your weapons gain paired. You cannot pair two-handed weapons this way. While you have paired weapons in your gear grid, you may spend activation to Deflect 2.",
    "observationCondition": "When you make a paired attack, gain +1 observation.",
    "boxes": 8,
    "levelUp": "Hissing Arms III"
    },
    {
    "name": "Hissing Arms",
    "level": "III",
    "lumiCost": 5,
    "traits": "knowledge, tenet, verminism",
    "rules": "All your weapons gain paired. You cannot pair two-handed weapons this way. While you have paired weapons in your gear grid, you may spend activation to Deflect 3.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Hunger",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, starting",
    "rules": "Your body is filled with tiny monsters that are eating you from the inside. +1 systemic pressure",
    "observationCondition": "During the Aftermath, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Hunger II"
    },
    {
    "name": "Hunger",
    "level": "II",
    "lumiCost": 0,
    "traits": "knowledge, starting",
    "rules": "You must eat monsters to feed the monsters inside. When you depart, gain +1 survival.",
    "observationCondition": "When you consume, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Hunger III"
    },
    {
    "name": "Hunger",
    "level": "III",
    "lumiCost": 1,
    "traits": "knowledge, starting",
    "rules": "With extreme focus and a controlled hum, you direct your appendix to secrete a unique gut bacteria that allows your intestines to super-absorb nutrients. When you depart, gain +2 survival.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Imagination",
    "level": null,
    "lumiCost": 4,
    "traits": "knowledge, romanticism",
    "rules": "You may spend 3 lumi to gain a rank of weapon proficiency. Limit once per lantern year.",
    "observationCondition": "When you depart with 12 or more lumi, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Epiphany Freedom"
    },
    {
    "name": "Juggernaut",
    "level": "I",
    "lumiCost": 3,
    "traits": "knowledge, gourmandism",
    "rules": "You have amassed a protective bulk. When you suffer a severe injury, you may archive 2 positive attribute tokens to ignore it.",
    "observationCondition": "When you use this, gain +1 observation.",
    "boxes": 4,
    "levelUp": "Juggernaut II"
    },
    {
    "name": "Juggernaut",
    "level": "II",
    "lumiCost": 6,
    "traits": "knowledge, gourmandism",
    "rules": "You are insulated by your distinguished mass. When you suffer a severe injury, you may archive 1 positive attribute token to ignore it.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Lanterns' Souls",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, lanternism",
    "rules": "You understand the lantern's truth. When you depart, +1 affinity of your choice.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Legion",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, collectivism",
    "rules": "Theory",
    "observationCondition": "When another survivor in the settlement has Legion, +1 observation.",
    "boxes": 1,
    "levelUp": "Legion II"
    },
    {
    "name": "Legion",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, collectivism",
    "rules": "You may spend 3 lumi to teach another survivor Legion. Limit once per lantern year.",
    "observationCondition": "When there are 8 survivors in the settlement with Legion, +1 observation.",
    "boxes": 1,
    "levelUp": "Legion III"
    },
    {
    "name": "Legion",
    "level": "III",
    "lumiCost": 4,
    "traits": "knowledge, collectivism",
    "rules": "You gain strength equal to the number of survivors with Legion on the showdown board.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Light Eater",
    "level": null,
    "lumiCost": 3,
    "traits": "knowledge, lanternism",
    "rules": "Subconsious. On Arrival, gain a death token. Activation: Consume a death token. Archive it and suffer the frenzy brain trauma.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Light Stealer",
    "level": null,
    "lumiCost": 1,
    "traits": "knowledge, lanternism",
    "rules": "After you successfully wound the monster, you may end your attack and attempt to steal the monster's soul. Roll 1d10 and slap one of your spare broken lanterns. On a 3+, it blinks to life! A sure sign that you were successful. Gain a death token. Limit Star times per showdown.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Light Warrior",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, lanternism",
    "rules": "On Arrival, gain a death token. Activation: Gain +2 strength for each death token you have until the end of your next attack. Then roll 1d10. On a 1, you consume a death token! Archive it and suffer the frenzy brain trauma.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Light Whisperer",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, lanternism",
    "rules": "On Arrival, gain a death token. Activation: Reveal cards from the top of the hit location deck equal to your number of death tokens and put them back in any order. Then roll 1d10. On a 1, you consume a death token! Archive it and suffer the frenzy brain trauma.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Limit Break",
    "level": null,
    "lumiCost": 4,
    "traits": "knowledge, impermanism",
    "rules": "At the start of the showdown, you may press your breaking points. If you do, gain +1 movement, accuracy, evasion, strength, and luck. You will die during the Aftermath, but not before passing on what you have learned. In the Aftermath, nominate another survivor. They gain this knowledge.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Marrow Monarch",
    "level": null,
    "lumiCost": 6,
    "traits": "knowledge, marrowism",
    "rules": "Marrowists gain the Cutthroat ability.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Meat Shield",
    "level": null,
    "lumiCost": 1,
    "traits": "knowledge, survivalism",
    "rules": "Before resolving damage from a monster's Move & Attack action, you may exchange places with a survivor adjacent to you. They suffer any damage in your stead! A switched survivor cannot perform Meat Shield or dodge.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": ""
    },
    {
    "name": "Mirror Eyes",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, verminism",
    "rules": "Theory",
    "observationCondition": "When you hit the monster at least two times in one attack, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Mirror Eyes II"
    },
    {
    "name": "Mirror Eyes",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, verminism",
    "rules": "When you make a paired attack, it gains Precision 1.",
    "observationCondition": "When you hit the monster at least three times in one attack, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Mirror Eyes III"
    },
    {
    "name": "Mirror Eyes",
    "level": "III",
    "lumiCost": 6,
    "traits": "knowledge, verminism",
    "rules": "When you make a paired attack, it gains Precision 2.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Myrmidon's Call",
    "level": null,
    "lumiCost": 3,
    "traits": "knowledge, collectivism\tYou encourage without spending survival.",
    "rules": "When you encourage a survivor, they gain +2 movement tokens until the end of the round.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Osteophage",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, tenet, marrowism",
    "rules": "You may archive a bone resource to consume it. If you do, gain the Marrow Hunger impairment.",
    "observationCondition": "When you consume a bone, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Osteophage II"
    },
    {
    "name": "Osteophage",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, tenet, marrowism",
    "rules": "You may archive a bone resource to consume it. If you do, gain the Marrow Hunger impairment. When you depart with no armor and no shield in your gear grid, add 1 armor to all hit locations for each observation in this knowledge.",
    "observationCondition": "When you consume a bone, gain +1 observation.",
    "boxes": 5,
    "levelUp": "Osteophage III"
    },
    {
    "name": "Osteophage",
    "level": "III",
    "lumiCost": 5,
    "traits": "knowledge, tenet, marrowism",
    "rules": "You may archive a bone resource to consume it. If you do, heal your survivor. Limit once per lantern year. When you depart with no armor and no shield in your gear grid, add 6 armor to all hit locations.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Perfect Physique",
    "level": null,
    "lumiCost": 1,
    "traits": "knowledge, marrowism",
    "rules": "At the beginning of your act, you may hypercontract every muscle in your body. Gain +3 strength and -3 movement until the end of the round.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Physiognomy",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, tenet, faceism",
    "rules": "You study the visages that surround you. During showdown setup, draw an additional Terrain Card and place it according to its setup rules.",
    "observationCondition": "When you activate terrain, gain +1 observation.",
    "boxes": 5,
    "levelUp": "Physiognomy II"
    },
    {
    "name": "Physiognomy",
    "level": "II",
    "lumiCost": 3,
    "traits": "knowledge, tenet, faceism",
    "rules": "During showdown setup, draw two additional Terrain Cards and pick one to place according to its setup rules.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Plausibility",
    "level": "I",
    "lumiCost": 1,
    "traits": "knowledge, monster, phoenix",
    "rules": "Theory",
    "observationCondition": "When you suffer a severe injury, gain +1 observation.",
    "boxes": 2,
    "levelUp": "Plausibility II"
    },
    {
    "name": "Plausibility",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, monster, phoenix",
    "rules": "After you suffer a severe injury, gain a reroll token.",
    "observationCondition": "When you use a reroll token on a severe injury roll, gain +1 observation.",
    "boxes": 4,
    "levelUp": "Plausibility III"
    },
    {
    "name": "Plausibility",
    "level": "III",
    "lumiCost": 6,
    "traits": "knowledge, monster, phoenix",
    "rules": "When you suffer a severe injury, but before you roll, gain a reroll token.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": ""
    },
    {
    "name": "Positivity",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, tenet, optimism",
    "rules": "On Arrival, if your survival is at the settlement's survival limit, gain 1 reroll token.",
    "observationCondition": "In the Aftermath, if your survival is at the settlement's survival limit, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Positivity II"
    },
    {
    "name": "Positivity",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, tenet, optimism",
    "rules": "On Arrival, if your survival is at the settlement's survival limit, gain 2 reroll tokens.",
    "observationCondition": "In the Aftermath, gain +1 observation for each of your reroll tokens.",
    "boxes": 5,
    "levelUp": "Positivity III"
    },
    {
    "name": "Positivity",
    "level": "III",
    "lumiCost": 5,
    "traits": "knowledge, tenet, optimism",
    "rules": "On Arrival, if your survival is at the settlement's survival limit, gain 2 reroll tokens. When your reroll result is 9+, gain another reroll token.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Potentia Est",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, romanticism\tYou test the boundaries of your mind. Increase the total number of knowledges you can have by 1, to a limit of 4.",
    "rules": "When you depart with 4 knowledges, gain +1 observation.",
    "observationCondition": null,
    "boxes": 3,
    "levelUp": "Potentia Est II"
    },
    {
    "name": "Potentia Est",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, romanticism",
    "rules": "+1 torment. Increase the total number of knowledges you can have by 2, to a limit of 5.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": ""
    },
    {
    "name": "Psychopathy",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, homicidalism",
    "rules": "Reduce all brain damage suffered during the showdown by 1 (to a minimum of 1).",
    "observationCondition": "When you suffer brain damage during the showdown, gain +1 observation.",
    "boxes": 8,
    "levelUp": "Psychopathy II"
    },
    {
    "name": "Psychopathy",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, homicidalism",
    "rules": "Reduce all brain damage suffered during the showdown by 2 (to a minimum of 1).",
    "observationCondition": "When you suffer a brain trauma, gain +1 observation.",
    "boxes": 6,
    "levelUp": "Epiphany Void"
    },
    {
    "name": "Queen of Hands",
    "level": null,
    "lumiCost": 8,
    "traits": "knowledge, verminism",
    "rules": "+2 speed, +1 systemic pressureWhen the left and right columns of your gear grid match, you may cancel any number of hits in your attack before drawing Hit Locations. For each cancelled hit, +1 luck for the rest of the attack.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Razor's Edge",
    "level": null,
    "lumiCost": 4,
    "traits": "knowledge, homicidalism",
    "rules": "While you have no armor points, your attacks with melee weapons gain Devastating 1.",
    "observationCondition": "When you wound the monster, gain +1 dangerous observation.",
    "boxes": 2,
    "levelUp": "Gain +1 systemic pressure and erase this knowledge's observations."
    },
    {
    "name": "Relativity",
    "level": null,
    "lumiCost": 5,
    "traits": "knowledge, monster, king",
    "rules": "+1 torment, +1 systemic pressure. In the Aftermath, each survivor must gain +1 observation in a knowledge of their choice.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Relentless",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, monster, smog singers",
    "rules": "Theory",
    "observationCondition": "When a monster moves away from you during your attack, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Relentless II"
    },
    {
    "name": "Relentless",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, monster, smog singers",
    "rules": "When a monster moves away from you during your attack, you must pursue. Limit once per attack.",
    "observationCondition": "When you pursue and wound, gain +1 observation.",
    "boxes": 4,
    "levelUp": "Relentless III"
    },
    {
    "name": "Relentless",
    "level": "III",
    "lumiCost": 3,
    "traits": "knowledge, monster, smog singers",
    "rules": "When a monster moves away from you during your attack, you may pursue. Limit once per attack.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Rolling Dive",
    "level": null,
    "lumiCost": 1,
    "traits": "knowledge, survivalism",
    "rules": "+1 torment. When you are adjacent to the monster, you may spend Movement to place your survivor on any other unoccupied space adjacent to the monster.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Sculptor's Apprentice",
    "level": null,
    "lumiCost": 4,
    "traits": "knowledge, faceism",
    "rules": "During the hunt or showdown, you allow the stone in your heart to beat. Add 9 armor to all hit locations. During the Aftermath, you follow the trail of singing stone faces in search of the Sculptor, never to be seen again.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Serial Code",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, dreamism",
    "rules": "Theory",
    "observationCondition": "When you depart after the settlement has witnessed The Game, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Serial Code II"
    },
    {
    "name": "Serial Code",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, dreamism",
    "rules": "You have glimpsed a fragment of the Dream Keeper's plan for you. If you would die, you inexplicably survive. Suffer -1 permanent luck and lose this knowledge. Limit once per lifetime.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Shatterstar",
    "level": "I",
    "lumiCost": 1,
    "traits": "knowledge, tenet, impermanism",
    "rules": "When you attack with a Frail weapon, it excites you. Gain +1 strength until the end of the attack.\tWhen you attack with a Frail weapon, gain +1 observation.\t4\tAdvance Shatterstar II",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Shatterstar",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, tenet, impermanism",
    "rules": "When you attack with a Frail weapon, it excites you. Gain +2 strength until the end of the attack.",
    "observationCondition": "When you archive a Frail weapon, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Shatterstar III"
    },
    {
    "name": "Shatterstar",
    "level": "III",
    "lumiCost": 3,
    "traits": "knowledge, tenet, impermanism",
    "rules": "When you would archive a Frail weapon without a cracked token, put a cracked token on the weapon instead. When you attack with a Frail weapon, it excites you! Gain +2 strength until the end of the attack. If it has a cracked token, gain +5 strength instead.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Stone Architect",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, dreamism",
    "rules": "+1 torment. When you are a returning survivor, add +1 construction point to the dream project.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Stone Heart",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, faceism",
    "rules": "Theory",
    "observationCondition": "When you suffer a severe injury, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Stone Heart II"
    },
    {
    "name": "Stone Heart",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, faceism",
    "rules": "Add +1 to your severe injury roll results.",
    "observationCondition": "When you suffer a severe injury, gain +1 observation.",
    "boxes": 5,
    "levelUp": "Stone Heart III"
    },
    {
    "name": "Stone Heart",
    "level": "III",
    "lumiCost": 5,
    "traits": "knowledge, faceism",
    "rules": "Add +2 to your severe injury roll results.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Stone Skin",
    "level": "I",
    "lumiCost": 2,
    "traits": "knowledge, marrowism",
    "rules": "You are protected by an exterior shell. When a hit causes you to fill in a heavy injury, cancel any remaining damage from that hit.",
    "observationCondition": "When you fill in a heavy injury level, gain +1 observation.",
    "boxes": 8,
    "levelUp": "Exoskeleton II"
    },
    {
    "name": "Stone Skin",
    "level": "II",
    "lumiCost": 4,
    "traits": "knowledge, marrowism",
    "rules": "You are guarded by a robust outer carapce. When a hit causes you to fill in an injury level (light or heavy), cancel any remaining damage from that hit.",
    "observationCondition": "When you are a Rank 4 Marrowist, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Exoskeleton III"
    },
    {
    "name": "Stone Skin",
    "level": "III",
    "lumiCost": 8,
    "traits": "knowledge, marrowism",
    "rules": "Gain an additional light injury box at every hit location. When a hit causes you to fill in an injury level (light or heavy), cancel any remaining damage from that hit.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Stone Wrecker",
    "level": null,
    "lumiCost": 3,
    "traits": "knowledge, impermanism",
    "rules": "Once per showdown, if adjacent to a Stone Column, you may spend Activation to lift it as a weapon. Archive the terrain tile and gain the Stone Column rare gear. If you still have the gear during the Aftermath, archive it.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Story of the Four Hands",
    "level": null,
    "lumiCost": 4,
    "traits": "knowledge, champion",
    "rules": "Melee weapons gain Deadly 9 and ignore the monster's luck when you attack with them.",
    "observationCondition": "When you critically wound, gain +1 dangerous observation.",
    "boxes": 3,
    "levelUp": "The story ends. Read Champion - Rank 4."
    },
    {
    "name": "Story of the Gloaming",
    "level": null,
    "lumiCost": 4,
    "traits": "knowledge, champion",
    "rules": "The first time you ignore a hit from a drawn AI using Block or Deflect, the monster suffers a wound.",
    "observationCondition": "When you Block or Deflect, gain +1 dangerous observation.",
    "boxes": 2,
    "levelUp": "The story ends. Read Champion - Rank 4."
    },
    {
    "name": "Story of the Hunter's Arrow",
    "level": null,
    "lumiCost": 4,
    "traits": "knowledge, champion",
    "rules": "When you hit with a ranged weapon, you must reveal the entire Hit Location deck and select a hit location to attempt to wound. Then shuffle the deck.",
    "observationCondition": "When you hit with a ranged weapon, gain +1 dangerous observation.",
    "boxes": 3,
    "levelUp": "The story ends. Read Champion - Rank 4."
    },
    {
    "name": "Story of the Rootcrown",
    "level": null,
    "lumiCost": 4,
    "traits": "knowledge, champion",
    "rules": "When another survivor encourages you, they explode in a violent burst of blood. Dead. Survivors adjacent to them suffer Star severe injuries. Monsters adjacent to them suffer Star automatic wounds.",
    "observationCondition": "When you are encouraged, gain +1 dangerous observation.",
    "boxes": 2,
    "levelUp": "The story ends. Read Champion - Rank 4."
    },
    {
    "name": "Strength Training",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, survivalism",
    "rules": "Theory",
    "observationCondition": "When you wound the monster, gain +1 observation. Limit once per attack.",
    "boxes": 6,
    "levelUp": "Strength Training II"
    },
    {
    "name": "Strength Training",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, survivalism",
    "rules": "+1 strength, +1 systemic pressure",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Surgical Precision",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, marrowism",
    "rules": "If all the gear in your gear grid has the bone keyword, your weapons lose Frail and gain Sharp.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Sword & Shield Style",
    "level": null,
    "lumiCost": 3,
    "traits": "knowledge, regalism",
    "rules": "When you have sword specialization, you also have shield specialization, and vice versa.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Tactical Drag",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, monster, white lion",
    "rules": "Theory",
    "observationCondition": "When you spend Movement to escape a zone, gain +1 observation.",
    "boxes": 3,
    "levelUp": "Tactical Drag II"
    },
    {
    "name": "Tactical Drag",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, monster, white lion",
    "rules": "Spend Movement to drag an adjacent survivor, full move away from the monster, and place the survivor adjacent to you, knocked down. Then you collapse from the exertion and are also knocked down!",
    "observationCondition": "When another survivor would be attacked or suffer damage from a zone and your drag avoids that outcome, gain +1 observation.",
    "boxes": 4,
    "levelUp": "Tactical Drag III"
    },
    {
    "name": "Tactical Drag",
    "level": "III",
    "lumiCost": 3,
    "traits": "knowledge, monster, white lion",
    "rules": "Spend Movement to drag an adjacent survivor, full move away from the monster, and place the survivor adjacent to you, knocked down.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Team Sacrifice",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, collectivism",
    "rules": "Instead of rolling to pick a straggler during the hunt, you can choose to be the straggler. When you are the straggler, add +3 to your roll results.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Tenacity",
    "level": "I",
    "lumiCost": 1,
    "traits": "knowledge, tenet, survivalism",
    "rules": "When you depart, gain a survival token. You may spend a survival token at any time to gain +1 survival.",
    "observationCondition": "When you spend a survival token, gain +1 observation.",
    "boxes": 2,
    "levelUp": "Tenacity II"
    },
    {
    "name": "Tenacity",
    "level": "II",
    "lumiCost": 2,
    "traits": "knowledge, tenet, survivalism",
    "rules": "When you depart, gain 2 survival tokens. You may spend a survival token at any time to gain +1 survival.",
    "observationCondition": "When you spend a survival token, gain +1 observation.",
    "boxes": 6,
    "levelUp": "Tenacity III"
    },
    {
    "name": "Tenacity",
    "level": "III",
    "lumiCost": 4,
    "traits": "knowledge, tenet, survivalism",
    "rules": "When you depart, gain 3 survival tokens. You may spend a survival token at any time to gain +1 survival.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Tumble",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, survivalism",
    "rules": "When something would collide with you, roll 1d10. On a 7+, you successfully tumble out of harm's way. Instead, place your survivor standing on the closest free space outside of the collision path.",
    "observationCondition": "When you successfully Tumble, gain +1 observation.",
    "boxes": 2,
    "levelUp": "Tumble II"
    },
    {
    "name": "Tumble",
    "level": "II",
    "lumiCost": 1,
    "traits": "knowledge, survivalism",
    "rules": "When something would collide with you, roll 1d10. On a 6+, you successfully tumble out of harm's way. Instead, place your survivor standing on the closest free space outside of the collision path.",
    "observationCondition": "When you successfully Tumble, gain +1 observation.",
    "boxes": 5,
    "levelUp": "Tumble III"
    },
    {
    "name": "Tumble",
    "level": "III",
    "lumiCost": 2,
    "traits": "knowledge, survivalism",
    "rules": "When something would collide with you, roll 1d10. On a 5+, you successfully tumble out of harm's way. Instead, place your survivor standing on the closest free space outside of the collision path.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Unyielding",
    "level": "I",
    "lumiCost": 0,
    "traits": "knowledge, faceism",
    "rules": "Theory",
    "observationCondition": "When you are targeted by an AI Card, gain +1 observation.",
    "boxes": 5,
    "levelUp": "Unyielding II"
    },
    {
    "name": "Unyielding",
    "level": "II",
    "lumiCost": 3,
    "traits": "knowledge, faceism",
    "rules": "Reduce damage from every hit suffered by 1, to a minimum of 1.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Void",
    "level": null,
    "lumiCost": 6,
    "traits": "knowledge, homicidalism",
    "rules": "Submerge your mind into the abyss. +2 torment. Movement, Activation: For the rest of the showdown, you are unaffected by Intimidate actions and you cannot gain knowledge, observations, disorders, survival, or insanity.",
    "observationCondition": null,
    "boxes": null,
    "levelUp": null
    },
    {
    "name": "Wanderlust",
    "level": null,
    "lumiCost": 2,
    "traits": "knowledge, tenet, romanticism",
    "rules": "Every new experience brings forth another font of inspiration. When you gain Hunt XP during the hunt or showdown, gain that much lumi. (This includes the Aftermath.)",
    "observationCondition": "When you depart with 6 or more lumi, gain +1 observation.",
    "boxes": 1,
    "levelUp": "Epiphany Imagination"
    }
]


export default knowledge;